export default "__VITE_ASSET__CJOJjxNj__"